const Iffy = (props) => {
    const { is, children } = props;
    return is
        ? children // This is probably wrong usage
        : null;
};
Iffy.displayName = 'Iffy';
export default Iffy;
//# sourceMappingURL=Iffy.js.map